import ModelTypeConstants from 'constants/ModelTypeConstants';
import ResultsTableAdapter from 'notebook/integrations/results/ResultsTableAdapter';
import {ACTION_ARCHIVE_ROWS} from 'notebook/store/VersioningConstants';
import makeArchiveRowActionFunction from 'notebook/structured-tables/action-functions/makeArchiveRowActionFunction';
import {
  ActionResultType,
  performServerSideTableWriteActionWithAudits,
} from 'notebook/structured-tables/action-functions/PerformActionFunctions';
import {archiveRows, unarchiveRows} from 'notebook/structured-tables/ActionFunctionDAO';
import {ResultsArchiveModal} from 'notebook/structured-tables/components/modals/ResultsArchiveModal';
import {
  AxisContextMenuActionFunctionParameters,
  StructuredTableRow,
} from 'notebook/structured-tables/StructuredTableConstants';
import runModal from 'ui-library/runModal';

import {ResultsRowMetadata, ResultsTable, ResultsTableMetadata} from './ResultsTableConstants';

export const ARCHIVE_RESULT_ROW_ACTION_FUNCTION_CONFIG = {
  allowOutsideOfEntry: false,
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  getSelectedItems: (
    _structuredTable: ResultsTable,
    selectedRows: Array<StructuredTableRow<ResultsRowMetadata>>,
    _adapter: ResultsTableAdapter
  ) =>
    selectedRows
      .filter((row) => row.metadata.euid != null)
      .map((row) => ({
        modelType: ModelTypeConstants.ASSAY_RESULT,
        id: row.metadata.euid as string,
        rowId: row.rowId,
      })),
  onSelectForArchive: (
    actionFunctionParams: AxisContextMenuActionFunctionParameters<ResultsTableMetadata, ResultsRowMetadata>,
    items: Array<{id: string; rowId: string; modelType: ModelTypeConstants}>
  ): void => {
    runModal(ResultsArchiveModal, {
      onRequestSubmit: (archivePurpose: string) => {
        performServerSideTableWriteActionWithAudits({
          entryId: actionFunctionParams.entryOrTemplateId!,
          loadingScreenMessage: 'Archiving rows...',
          autoSaverAction: ACTION_ARCHIVE_ROWS,
          doPerformAction: async ({dataModsHeader}) => {
            await archiveRows(
              actionFunctionParams.entryOrTemplateId!,
              actionFunctionParams.structuredTable,
              actionFunctionParams.computedTable,
              actionFunctionParams.actionFunctionContext,
              items,
              archivePurpose,
              undefined,
              dataModsHeader
            );
            return {resultType: ActionResultType.SUCCESS, responseData: null};
          },
          analyticsActionForPerfTracking: 'archive_results_structured_table_rows',
          structuredTables: [actionFunctionParams.structuredTable],
          structuredTableAdapters: [actionFunctionParams.structuredTableAdapter],
          computedTables: [actionFunctionParams.computedTable],
          tables: actionFunctionParams.table ? [actionFunctionParams.table] : [],
        });
      },
      onRequestClose: () => {},
      numResults: items.length,
    });
  },
  onSelectForUnarchive: (
    actionFunctionParams: AxisContextMenuActionFunctionParameters<ResultsTableMetadata, ResultsRowMetadata>,
    items: Array<{id: string; modelType: ModelTypeConstants}>
  ): void => {
    performServerSideTableWriteActionWithAudits({
      entryId: actionFunctionParams.entryOrTemplateId!,
      loadingScreenMessage: 'Unarchiving rows...',
      autoSaverAction: ACTION_ARCHIVE_ROWS,
      doPerformAction: async ({dataModsHeader}) => {
        await unarchiveRows(
          actionFunctionParams.entryOrTemplateId!,
          actionFunctionParams.structuredTable,
          actionFunctionParams.computedTable,
          actionFunctionParams.actionFunctionContext,
          items,
          dataModsHeader
        );
        return {resultType: ActionResultType.SUCCESS, responseData: null};
      },
      analyticsActionForPerfTracking: 'unarchive_results_structured_table_rows',
      structuredTables: [actionFunctionParams.structuredTable],
      structuredTableAdapters: [actionFunctionParams.structuredTableAdapter],
      computedTables: [actionFunctionParams.computedTable],
      tables: actionFunctionParams.table ? [actionFunctionParams.table] : [],
    });
  },
};

export default makeArchiveRowActionFunction<ResultsTableMetadata, ResultsRowMetadata>(
  ARCHIVE_RESULT_ROW_ACTION_FUNCTION_CONFIG
);
